import map from 'lodash/map'
import sortBy from 'lodash/sortBy'
import groupBy from 'lodash/groupBy'

function getGroupKey(hole) {
    return hole.groupKey
}

function getGroupKeyWithTap(hole) {
    const { tapAnnotation } = hole

    return `${hole.groupKey}-${
        tapAnnotation ? tapAnnotation.tapOption.id : null
    }`
}

// Simple struct for storing group information
class HoleDiameterGroup {
    //eslint-disable-next-line max-params
    constructor(holes, groupKey, groupLetter, groupNumber) {
        this.holes = holes
        this.groupKey = groupKey
        this.groupLetter = groupLetter
        this.groupNumber = groupNumber
        this.groupTag = `${groupLetter}${groupNumber}`
    }
}

const ROOT_CHAR_CODE = 'A'.charCodeAt(0)

function getGroupTag(group) {
    return group.groupTag
}

export default function computeHoleGroups(holes, isDrawing) {
    const getKey = isDrawing ? getGroupKeyWithTap : getGroupKey
    const holesByGroupKey = groupBy(holes, getKey)

    let letterIdx = 0
    const tagMap = {}

    return sortBy(
        map(holesByGroupKey, (_holes, groupKey) => {
            const { diameter } = _holes[0]

            if (tagMap[diameter]) {
                tagMap[diameter].number++
            } else {
                tagMap[diameter] = {
                    letter: String.fromCharCode(ROOT_CHAR_CODE + letterIdx++),
                    number: 1,
                }
            }

            const groupLetter = tagMap[diameter].letter
            const groupNumber = tagMap[diameter].number

            return new HoleDiameterGroup(
                _holes,
                groupKey,
                groupLetter,
                groupNumber,
            )
        }),
        getGroupTag,
    )
}
